/**
 * Resolve which auth portal UI to show based on hostname.
 *
 * - admin.premierlab.ai → admin
 * - app.premierlab.ai   → user
 * - localhost / other   → user by default; `?portal=admin` for local admin UI
 */
export function resolveAuthVariant(hostname, search = "") {
  const host = String(hostname || "").toLowerCase();
  if (host === "admin.premierlab.ai" || host.startsWith("admin.")) {
    return "admin";
  }
  if (host === "app.premierlab.ai") {
    return "user";
  }
  try {
    const params = new URLSearchParams(
      typeof search === "string" ? search : ""
    );
    if (params.get("portal") === "admin") return "admin";
  } catch (_) {
    /* ignore */
  }
  return "user";
}

export function isAdminHostname(hostname) {
  return resolveAuthVariant(hostname, "") === "admin";
}

export function signupAllowed(hostname, search = "") {
  return resolveAuthVariant(hostname, search) === "user";
}
